module.exports = __webpack_public_path__ + "static/media/Black_logo.2f034189.svg";